import _findLastIndex from 'lodash/findLastIndex';
import * as orderEvents from '../order';
import { getProductsFromCart } from '../../helpers';
import * as cartTypes from '../../../modules/cart/actionTypes';
import { getRoute } from '../../../../entry/routes';

/**
 * Ивент для посещения корзины (Step 1) => Отправка Step 2(доставка)(по умолчанию) => Отправка Step 3(оплата)(по умолчанию)
 * @param {object} action
 * @param {object} prevState
 * @param {object} nextState
 * @returns {object} Ивент
 */
export function visitCheckout(action, prevState, nextState) {
  const {
    location: { current, previous },
    cart,
  } = nextState;

  const currentPath = current?.pathname;
  const prevPath = previous?.pathname;

  if (
    (prevPath !== getRoute('order') && currentPath === getRoute('order')) ||
    (prevPath === getRoute('order') &&
      currentPath === getRoute('order') &&
      action.type === cartTypes.FETCH_ITEMS_SUCCESS)
  ) {
    const actionField = {
      step: 1,
      option: nextState.user.isAuthenticated ? 'Авторизация' : 'Регистрация',
    };

    let products = [];

    if (cart) {
      products = getProductsFromCart(cart);
    }

    if (!products.length) {
      return null;
    }

    return {
      event: 'checkout',
      eventCategory: 'Ecommerce',
      eventAction: 'checkout',
      eventLabel: 'Step 1',
      ecommerce: {
        checkout: {
          actionField,
          products,
        },
      },
    };
  }

  return null;
}

export function sendDelivery(action, prevState, nextState) {
  const { cart, order } = nextState;
  const { deliveryType } = order.checkout;

  const actionField = {
    step: 2,
    option: deliveryType === 'delivery' ? 'Доставка' : 'Самовывоз',
  };

  let products = [];

  if (cart) {
    products = getProductsFromCart(cart);
  }

  const outData = {
    event: 'checkout',
    eventCategory: 'Ecommerce',
    eventAction: 'checkout',
    eventLabel: 'Step 2',

    ecommerce: {
      checkout: {
        actionField,
        products,
      },
    },
  };

  return outData;
}

export function sendPayment(action, prevState, nextState) {
  const { cart } = nextState;

  const actionField = {
    step: 3,
    option: 'Наличными курьеру',
  };

  let products = [];

  if (cart) {
    products = getProductsFromCart(cart);
  }

  const outData = {
    event: 'checkout',
    eventCategory: 'Ecommerce',
    eventAction: 'checkout',
    eventLabel: 'Step 3',

    ecommerce: {
      checkout: {
        actionField,
        products,
      },
    },
  };

  return outData;
}

/* ====== HANDLERS ====== */

export function changeDeliveryType(action, prevState, nextState) {
  const outItem = {
    event: 'checkoutOption',
    ecommerce: {
      checkout_option: {
        actionField: {
          step: 2,
          option: action.payload === 'delivery' ? 'Доставка' : 'Самовывоз',
        },
      },
    },
  };

  return outItem;
}

export function changePaymentType(action, prevState, nextState) {
  const getPayType = () => {
    switch (action.payload) {
      case 'cash': {
        return 'Наличными курьеру';
      }
      case 'card_to_courier': {
        return 'Картой курьеру';
      }
      case 'online': {
        return 'Банковской картой сейчас';
      }
      default: {
        return action.payload;
      }
    }
  };

  const outItem = {
    event: 'checkoutOption',
    ecommerce: {
      checkout_option: {
        actionField: {
          step: 3,
          option: getPayType(),
        },
      },
    },
  };

  return outItem;
}

export function handleAddressCheck(action, prevState, nextState) {
  const { analytAddress } = action;
  const isSuccess = action.type !== '@order/FETCH_DELIVERY_RESTAURANT_DETAILS_FAILURE';

  const actionPayloadAddress = ((action || {}).payload || {}).address;
  let outAddress = '';
  if (actionPayloadAddress) {
    outAddress = actionPayloadAddress;
  }

  const outData = {
    event: 'UA event',
    eventCategory: 'Проверка адреса',
    eventAction: isSuccess ? 'Доставка есть' : outAddress,
    eventLabel: analytAddress,
    deliveryAvailable: isSuccess ? 'Доставка есть' : 'Доставки нет',
  };

  return analytAddress ? outData : null;
}

// REDUCER

export const getCheckoutEvents = (actionType, tryFunc) => {
  try {
    let dataLayer = [];

    if (window.dataLayer) {
      dataLayer = [...window.dataLayer];
    }

    // Находим индекс последнего захода в корзину
    const lastStepOneEventIndex = _findLastIndex(
      dataLayer,
      item => item.event === 'checkout' && item.ecommerce?.checkout?.actionField?.step === 1,
    );

    // Находим индекс последнего действия в корзине
    const lastEventIndex = _findLastIndex(dataLayer, item => item.event === 'checkout');

    if (dataLayer[lastEventIndex]?.ecommerce?.checkout?.actionField?.step === 4) {
      // Если последним ивентом был PAY_SUCCESS и не было нового захода в корзину, то в GTM ничего не отправляем
      return null;
    }

    if (lastStepOneEventIndex <= lastEventIndex) {
      const outActions = [];

      // Get last Checkout GTM events Step 1..Step 4
      const subArr = dataLayer
        .slice(lastStepOneEventIndex, lastEventIndex + 1)
        .filter(item => item.event === 'checkout');

      // Check if STEP 2 was already submitted
      const hasSecond =
        subArr.findIndex(item => item.ecommerce?.checkout?.actionField?.step === 2) > -1;

      // Check if STEP 3 was already submitted
      const hasThird =
        subArr.findIndex(item => item.ecommerce?.checkout?.actionField?.step === 3) > -1;

      // Build Array of events depending on ActionType, hasSecond, hasThird
      switch (actionType) {
        case '@order/SET_CHECKOUT_DELIVERY_TYPE':
          // Если второй шаг не был отправлен, отправляем его
          if (!hasSecond) {
            outActions.push(tryFunc(sendDelivery));
          }

          // Push DELIVERY_TYPE change event
          outActions.push(tryFunc(changeDeliveryType));
          break;

        case '@order/SET_CHECKOUT_PAY_TYPE':
          // Если второй шаг не был отправлен, отправляем его
          if (!hasSecond) {
            outActions.push(tryFunc(sendDelivery));
          }

          // Если третий шаг не был отправлен, отправляем его
          if (!hasThird) {
            outActions.push(tryFunc(sendPayment));
          }

          // Push PAY_TYPE change event
          outActions.push(tryFunc(changePaymentType));
          break;

        case '@analytic/ORDER_SENDED':
          // Если второй шаг не был отправлен, отправляем его
          if (!hasSecond) {
            outActions.push(tryFunc(sendDelivery));
          }

          // Если третий шаг не был отправлен, отправляем его
          if (!hasThird) {
            outActions.push(tryFunc(sendPayment));
          }

          // Push PAY_SUCCESS event
          outActions.push(tryFunc(orderEvents.paySuccess));
          break;

        default:
          break;
      }

      return outActions;
    }

    return null;
  } catch ({ message }) {
    console.warn(`[checkout analyt] Error when getting checkout events: ${message}`);
    return null;
  }
};
